import { render, staticRenderFns } from "./ModeloUpdate.vue?vue&type=template&id=7683bdc0&scoped=true&"
import script from "./ModeloUpdate.vue?vue&type=script&lang=js&"
export * from "./ModeloUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7683bdc0",
  null
  
)

export default component.exports